import { fleetManagementApi } from "../api";

export const getDrivers = async (params = {}) => {
  const response = await fleetManagementApi.get("/drivers", { params });
  return response;
}

export const getDriverById = async (driverId) => {
  const response = await fleetManagementApi.get(`/drivers/${driverId}`);
  return response;
}

export const createDriver = async (driverData) => {
  const response = await fleetManagementApi.post("/drivers", driverData);
  return response;
}

export const updateDriver = async (driverId, driverData) => {
  const response = await fleetManagementApi.put(`/drivers/${driverId}`, driverData);
  return response;
}

export const deleteDriver = async (driverId) => {
  const response = await fleetManagementApi.delete(`/drivers/${driverId}`);
  return response;
}